<template>
  <div class="q-pa-lg" style="background: #fff;padding-bottom: 60px;">
    <div class="box">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input v-model="imei" placeholder="IMEI号/设备号" />
        </el-form-item>
        <el-form-item>
          <el-select filterable allow-create default-first-option v-model="startTime" placeholder="账期">
            <el-option v-for="(item,index) in timeList" :key="index"
                       :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div>
        <el-button size="small" @click="list(1)" type="primary" icon="el-icon-search">搜索</el-button>
      </div>
    </div>

    <div style="margin-top: 1%">
      <el-card>
        <span style="margin-left: 2%">IMEI: {{deviceInfo.imei}}</span>
        <span style="margin-left: 2%;color: #097bdd">设备号: {{deviceInfo.cardDefineNo}}</span>
        <span style="margin-left: 2%;color: #097bdd">SIM1: {{deviceInfo.iccid}}</span>
        <span style="margin-left: 2%;color: #097bdd">ESIM2: {{deviceInfo.twoIccid}}</span>
        <span v-if="deviceInfo.status===0" style="margin-left: 2%">设备通讯状态: 未激活</span>
        <span v-if="deviceInfo.status===1" style="margin-left: 2%">设备通讯状态: 在用</span>
        <span v-if="deviceInfo.status===2" style="margin-left: 2%">设备通讯状态: 停机</span>
        <span  style="margin-left: 5%">在用: {{deviceInfo.mainIccid}}</span>
        <span style="margin-left: 10%">账期: {{startTime}}</span>
      </el-card>
    </div>

    <el-table :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
              :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
              :cell-style="{height:'5px,0',textAlign:'center'}" :max-height="maxHeight"
              style="width: 100%;margin-top: 1%" border>
      <el-table-column label="ID" prop="id" width="100">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="加油包名称" prop="packetName" width="180">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="套餐总量（含so）" prop="trueFlow" width="180">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="已用总量（含so)"  width="180">
        <template slot-scope="scope">
          <div>{{parseFloat(scope.row.useSoFlow + scope.row.useFlow).toFixed(2)}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="剩余总量（含so）"  width="180">
        <template slot-scope="scope">
          <div>{{parseFloat(scope.row.trueFlow-(scope.row.useSoFlow + scope.row.useFlow)).toFixed(2)}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="SIM1" width="180">
        <span>{{deviceInfo.iccid}}</span>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="ESIM2"  width="180">
        <span>{{deviceInfo.twoIccid}}</span>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="状态"  width="180">
        <template slot-scope="scope">
          <div style="color: orange" v-if="scope.row.status===1 && Date.parse(scope.row.startTime)>new Date() ">待生效</div>
          <div style="color: green" v-else>生效</div>
          <div style="color: #cccccc" v-if="scope.row.status===0">失效</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="订单单号" prop="ordNo" width="195">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="卡槽切割分比" prop="radioFlow" width="100">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="计费开始时间" prop="startTime" width="180">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="计费结束时间" prop="endTime" width="180">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="套餐订购时间" prop="createTime" width="180">
      </el-table-column>
      <el-table-column fixed="right" show-overflow-tooltip label="用量详情" prop="createTime" width="180">
        <template slot-scope="scope">
          <span @click="lookflow(scope.row)" style="color:#097bdd;cursor: pointer">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

    <el-dialog :close-on-click-modal="false" :visible.sync="cardFlowBox"  title="设备中卡用量详情"
               class="class_dialog_hospital" width="70%">

      <span>卡详情：</span>
      <el-table :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                :data="cardData" :row-style="{height:'40px',textAlign:'center'}"
                :cell-style="{height:'5px,0',textAlign:'center'}" :max-height="maxHeight"
                style="width: 100%;margin-top: 1%;margin-bottom: 3%" border>
        <el-table-column label="ID" prop="id" show-overflow-tooltip width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="ICCID" prop="iccid"  width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="通道" prop="cardType" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="客户" prop="agentId" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="剩余流量" prop="remain"  width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="已用流量" prop="used"  width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="卡状态"  width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.status===100">异常</div>
            <div v-if="scope.row.status===99">更新中...</div>
            <div v-if="scope.row.status===0">待激活</div>
            <div v-if="scope.row.status===1">正常</div>
            <div v-if="scope.row.status===2">停机</div>
          </template>
        </el-table-column>
      </el-table>

      <span style="margin-top: 3%">卡用量详情：</span>
      <el-table :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                :data="cardFlowData.slice((currentPage-1)*pageSize,currentPage*pageSize)" :row-style="{height:'40px',textAlign:'center'}"
                :cell-style="{height:'5px,0',textAlign:'center'}" :max-height="maxHeight"
                style="width: 100%;margin-top: 1%" border>
        <el-table-column label="ID" prop="id" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="加油包名称"  width="180">
          <span>设备专属套餐</span>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="ICCID" prop="iccid" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="套餐总量（含so）" prop="trueFlow" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="已用总量（含so）" width="180">
          <template slot-scope="scope">
            <div>{{scope.row.useFlow+scope.row.useSoFlow}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="剩余总量（含so）"  width="180">
          <template slot-scope="scope">
            <div>{{scope.row.trueFlow-(scope.row.useFlow+scope.row.useSoFlow)}}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="状态"  width="180">
          <template slot-scope="scope">
            <div style="color: orange" v-if="scope.row.status===1 && Date.parse(scope.row.startTime)>new Date() ">待生效</div>
            <div style="color: green" v-else>生效</div>
            <div style="color: #cccccc" v-if="scope.row.status===0">失效</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="订单单号" prop="ordNo" width="195">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="计费开始时间" prop="startTime" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="计费结束时间" prop="endTime" width="180">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="套餐订购时间" prop="createTime" width="180">
        </el-table-column>
      </el-table>
      <!--分页按钮-->
      <el-pagination
              background
              layout="prev, pager, next,jumper, ->, total"
              :total="cardFlowCount"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              style="text-align: center;margin-top: 2%">
      </el-pagination>
    </el-dialog>


  </div>
</template>

<script>
import Pagination from '../../components/pagination'
export default {
  name: 'Equipment',
  data() {
    return {
      cardData:[],
      currentPage:1,
      pageSize:10,
      cardFlowCount:0,
      cardFlowBox:false,
      cardFlowData:[],
      deviceInfo:{},
      imei:'',
      cardDefineNo: '',
      startTime: '',
      timeList:[],
      deviceMap:{
        pageNo:1,
        pageSize:10,
      },
      maxHeight: 500,
      tableData: [],
      showShipments: false
    }
  },
  components: {
    Pagination
  },
  mounted() {
    this.initTime()
    //获取当前时间
    let date = new Date()
    let month = parseInt(date.getMonth()+1)<10?"0"+parseInt(date.getMonth()+1):parseInt(date.getMonth()+1)
    this.startTime = date.getFullYear()+"-"+month
  },
  methods: {
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
    },
    async lookflow(row){
      let that=this
      that.cardFlowData=[]
      //获取套餐
      const {data:res}=await that.$ajax.get(process.env.VUE_APP_SERVER + '/device/device-info/get-device-card-flow-list',{
        params:{
          imei: row.imei,
          ordNo: row.ordNo
        }
      })
      if(res.code!=='0'){
        that.$alert(res.msg,'失败')
        return false
      }
      that.cardFlowData = res.data.rows
      that.cardFlowCount =res.data.total
      that.cardData=res.data.cardIndexList
      that.cardFlowBox=true
    },
    initTime(){
      let date=new Date()
      let year=date.getFullYear()
      let month=date.getMonth()
      let temp=0
      for(let i=1;i<50;i++){
        let m= i
        if(parseInt(i)<10){
          m = "0"+i
        }
        if(parseInt(i)>12){
          continue
        }
        this.timeList.push(year+"-"+m)
      }
    },
    beforeHandleCommand(row, command, item, index) {
      return {
        row: row,
        command: command,
        item: item,
        index: index
      }
    },
    handlerCommand(command) {
      let _this = this
      switch (command.command) {
        case 'updateWifiName':
          break
        case 'updateWifiPwd':
          break
        case 'cutSim':
          break
        case 'resetWebPwd':
          break
        case 'resetDevice':
          break
        case 'resstartDevice':
          _this.updateTF(command.row.iccid, 'on')
          break
      }
    },
    async list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.tableData = []
      const {data:res}= await _this.$ajax.get(process.env.VUE_APP_SERVER + '/device/device-info/query-device-flow-list', {
                params:{
                  pageNo: page,
                  pageSize: _this.$refs.pagination.size,
                  imei: _this.imei,
                  startTime: _this.startTime
                }
              })
      if(res.code!=='0'){
        _this.$alert(res.msg,'失败')
        return false
      }
      _this.tableData = res.data.rows
      _this.deviceInfo=res.data.deviceInfo
      _this.$refs.pagination.render(page, res.data.total)
    },
  }
}
</script>

<style lang="css">
.el-tooltip__popper {
  max-width: 70%;
}
</style>
<style scoped>

  /*滚动条样式*/
  /deep/ ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }
  /deep/ ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 8px;
    box-shadow: inset 5px 0px 5px #f0f0f0;
    background: #d9d9d9;
  }
  /deep/ ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px #f0f0f0;
    border-radius: 8px;
    background: #ffffff;
  }

/deep/.el-table .el-table__cell {
  padding: 9px;
}
/deep/thead.has-gutter {
  height: 40px;
}
</style>
<style scoped>
.box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
/deep/ .el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}
/* --------------------------弹窗样式------------------------------ */
/*标题样式*/
/deep/.class_dialog_hospital .el-dialog__title {
  font-size: 15px;
  margin-left: 15px;
}

/*头区样式*/
/deep/.class_dialog_hospital .el-dialog__header {
  height: 50px;
  background: #e6e6e6;
  padding: 15px 0 4px 10px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
}

/*头区退出按钮样式*/
/deep/.class_dialog_hospital .el-dialog__headerbtn {
  top: 14px;
  right: 20px;
  font-size: 16px;
}

/*对话框区*/
/deep/.class_dialog_hospital .el-dialog {
  border: 1px solid #dcdfe6;
  box-shadow: 0 0 4px #e6e6e6;
  border-radius: 9px;
  padding: 0;
}

/*内容区*/
/deep/.class_dialog_hospital .el-dialog__body {
  padding: 20px;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
  font-weight: 700;
}

/*脚区*/
/deep/.class_dialog_hospital .el-dialog__footer {
  border-top: 2px solid #e8eaec;
  padding: 16px;
}
</style>